module.exports = __webpack_public_path__ + "static/media/icon-outline-power-red.351e1ee9.svg";